import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import NoDataFound from "../NoDataFound";

const DynamicList = ({ columnsData, rowsData, loading }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setColumns(columnsData);
    setRows(rowsData);
  }, [columnsData, rowsData]);

  function getTableBody() {
    if (loading) {
      return (
        <tr>
          <td
            colSpan={columns.length + 1}
            style={{ textAlign: "center", height: "370px" }}
          >
            <div className="loader-new"></div>
          </td>
        </tr>
      );
    }

    if (rows.length === 0) {
      return (
        <tr>
          <td colSpan={columns.length + 1} style={{ textAlign: "center" }}>
            <NoDataFound title="No Data Found" />
          </td>
        </tr>
      );
    }

    return (
      rows.length > 0 &&
      columns.length > 0 &&
      rows.map((item, rowIndex) => {
        return (
          <tr key={rowIndex}>
            <td>
              <NavLink
                to={`/chat/${item.customer_tattle_uuid}`}
                className="chat-link"
              >
                {item.customer_tattle_uuid}
              </NavLink>
            </td>
            {columns.map((col, colIndex) => {
              if (col.field === "name") {
                return (
                  <td key={colIndex}>
                    {item[col.field].slice(0, 20) +
                      (item.name.length > 20 ? "..." : "")}
                    {/* <span className="chat-badge">{item.line}</span> */}
                  </td>
                );
              }
              if (col.field === "preview") {
                return (
                  <td key={colIndex}>
                    {item[col.field].slice(0, 20) +
                      (item.preview.length > 20 ? "..." : "")}
                    {/* <span className="chat-badge">{item.line}</span> */}
                  </td>
                );
              }

              if (col.field === "ideas") {
                if (item[col.field] && Array.isArray(item[col.field])) {
                  return (
                    <td key={colIndex}>
                      {item[col.field].map((idea, ideaIndex) => (
                        <React.Fragment key={ideaIndex}>
                          <a
                            href={`https://tattle.allthingsott.com/tattle/ideas/${idea}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {idea}
                          </a>
                          {ideaIndex !== item[col.field].length - 1 && ", "}
                        </React.Fragment>
                      ))}
                    </td>
                  );
                }
              }

              if (col.field === "date") {
                const date = new Date(item.timestamp);
                const utcDateString = date.toISOString().split("T")[0];
                return (
                  <td key={colIndex}>
                    {new Date(utcDateString).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                );
              }

              const options = col.hasOwnProperty("options")
                ? col.options
                : null;

              if (options) {
                const val = options.find(
                  (option) => option.id || option._id === item[col.field]
                );
                return (
                  <td key={colIndex}>
                    {val ? val.value || val.option_name : item[col.field]}
                  </td>
                );
              }

              return <td key={colIndex}>{item[col.field]}</td>;
            })}
          </tr>
        );
      })
    );
  }

  return (
    <div className="body-content">
      <div className="table-wrap">
        <table style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              {columns.length > 0 && <th width="95">ID </th>}
              {columns.map((col) => (
                <th width={`${col.width}px`} key={col.field}>
                  {col.headerName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{getTableBody()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default DynamicList;



// WEBPACK FOOTER //
// ./src/components/chat/components/DynamicList.js